import { getInstance } from '../StateManager';
import { update } from 'Emitter';
import { MEDIA, UI, APPLICATION } from 'StateEvents';
import Updater from './Updater';
import * as VPAIDEvents from 'Enum/VPAIDEvents';

export default class MediaUpdater extends Updater {
  constructor() {
    super();
    this.addRelevant(MEDIA);
    this.relevantEvents.push(UI.SKIPPED);
  }

  updateState(newState, event) {
    const videoEl = event.args && event.args.length && event.args[0].target;

    switch(event.name) {
      case MEDIA.STARTED:
        newState.media.started = true;
        break;
      case MEDIA.DURATION_CHANGE:
        if(videoEl.duration > 0) {
          newState.media.duration = videoEl.duration;
        } else if(videoEl.duration === -1) {
          update(APPLICATION.ERROR, 'MediaUpdater.updateState', 'unable to measure media - duration unavailable');
        }
        break;
      case MEDIA.TIME_UPDATE:
        newState.media.current_time = videoEl.currentTime;
        break;
      case MEDIA.COMPLETE:
        newState.media.complete = true;
        break;
      case MEDIA.MESSAGE_RECEIVED:
        newState.media.received = newState.media.received.concat(event.args[0]);
        newState.media.paused = newState.media.received.slice(-1).join('') === VPAIDEvents.AD_PAUSED;
        break;
      case MEDIA.VOLUME_CHANGE:
        newState.media.volume = event.args;
        break;
      case UI.SKIPPED:
        newState.media.skipped = true;
        break;
    }

    return newState;
  }
}

getInstance().registerUpdater(new MediaUpdater());


// WEBPACK FOOTER //
// ./src/Services/State/Updaters/MediaUpdater.js